module.exports = __webpack_public_path__ + "img/autio-line.3fd19465.svg";